import { STATE_KEY } from './data.const';

const mainSelector = (state: any) => state[STATE_KEY];

export const selectLoaders = (state: any) => mainSelector(state).loaders;
export const getUser = (state: any) => mainSelector(state).user;
export const getGames = (state: any) => mainSelector(state).games;
export const getQrCodeStatus = (state: any) => mainSelector(state).qrCodeStatus;
